









































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'ShareDialog'
})

export default class ShareDialog extends Vue {

  popoverElementId = '';

  created() {

    // Any old ID will do
    this.popoverElementId = `${Math.abs(Math.random())}`;
  }

  get currentUrl() {
    return window.location.href;
  }

  handlePopoverShown() {
    this.focusInput();
  }

  handleClosePopover() {
    this.$root.$emit('bv::hide::popover', this.popoverElementId)
  }

  handleCopy() {

    // Copy shit to textboard
    navigator.clipboard.writeText(`${this.currentUrl}?ref=share`);

    // Refocus link
    this.focusInput();
  }

  focusInput() {
    const input = (this.$refs.sharePopoverInput as HTMLInputElement)
    input.focus();
    input.select();
  }
}

